import { Outlet } from 'react-router-dom'
import { Topbar } from './components/Topbar'
import { Sidebar } from './components/Sidebar'
import { ViewAsBanner } from './components/ViewAsBanner'
import { CurrencyProvider } from './lib/currency-context'
import { PeriodProvider } from './lib/period-context'
import { LearnModeProvider } from './lib/learn-mode'

export function App() {
  return (
    <CurrencyProvider>
      <PeriodProvider>
        <LearnModeProvider>
          <div className="min-h-screen">
            <ViewAsBanner />
            <Topbar />
            <div className="flex">
              <Sidebar />
              <main className="flex-1 min-w-0 px-8 py-8 max-w-[1400px] mx-auto w-full">
                <Outlet />
              </main>
            </div>
          </div>
        </LearnModeProvider>
      </PeriodProvider>
    </CurrencyProvider>
  )
}
